<script lang="ts">
	import type { Attachment } from "svelte/attachments";
	import type { HTMLAttributes } from "svelte/elements";
	import {
		type HTMLPPLAccessPointWidgetElement,
		type PPLAccessPointWidgetEventAttributes,
		type WidgetConfig,
		ensurePplAccessPointWidgetLoaded,
		prepareWidget,
	} from "./PPLAccessPoint.js";

	let {
		instance = $bindable<HTMLPPLAccessPointWidgetElement | undefined>(),
		error = $bindable<Error | undefined>(),
		/* eslint-disable prefer-const */
		apiKey,
		config,
		...rest
		/* eslint-enable prefer-const */
	}: {
		instance?: HTMLPPLAccessPointWidgetElement;
		error?: Error;
		apiKey: string;
		config: WidgetConfig;
	} & PPLAccessPointWidgetEventAttributes &
		HTMLAttributes<HTMLPPLAccessPointWidgetElement> = $props();

	$effect(() => {
		const pplWidget = instance;
		if (!pplWidget) {
			return;
		}
		pplWidget.widgetConfig = config;
		return (): void => {
			pplWidget.reset();
		};
	});

	async function setupDiv(div: HTMLDivElement): Promise<void> {
		try {
			await ensurePplAccessPointWidgetLoaded();
			const widget = await prepareWidget(div, config, apiKey);
			widget.style.all = "inherit";
			widget.style.display = "block";
			instance = widget;
		} catch (caught) {
			error = caught instanceof Error ? caught : new Error(String(caught));
		}
	}

	const configure: Attachment<HTMLDivElement> = (div) => {
		void setupDiv(div);
	};
</script>

<div {...rest as HTMLAttributes<HTMLDivElement>} {@attach configure} style:display="contents"></div>
